/**
 * Keep PDP / Quick View price + ATC button in sync when variants change.
 * Binds directly to <variant-selection> (events may not bubble in older builds).
 */
(function () {
  var bound = new WeakSet();

  function formatMoney(cents) {
    var moneyFormat = document.body && document.body.dataset.moneyFormat;
    if (window.Shopify && Shopify.currencyHelper && typeof Shopify.currencyHelper.formatMoney === 'function') {
      return Shopify.currencyHelper.formatMoney(cents, moneyFormat);
    }
    return (Number(cents) / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
    });
  }

  function scopeFor(target) {
    return (
      target.closest('.quickshop-modal') ||
      target.closest('[data-product-component]') ||
      target.closest('[data-product-details]') ||
      target.closest('.shopify-section') ||
      document
    );
  }

  function updateAtc(scope, variant, state) {
    var atcButton = scope.querySelector('[data-product-atc]');
    var atcButtonText = scope.querySelector('[data-product-atc-text]');
    if (!atcButton || !atcButtonText) return;

    var translation = (window.PXUTheme && PXUTheme.translation) || {};
    var addLabel =
      atcButton.getAttribute('data-label') ||
      atcButton.dataset.label ||
      'Add to Cart';

    if (!variant || state === 'unavailable' || state === 'not-selected') {
      atcButtonText.innerText = translation.product_unavailable || 'Unavailable';
      atcButton.disabled = true;
      return;
    }

    if (variant.available) {
      atcButtonText.innerText = addLabel;
      atcButton.disabled = false;
    } else {
      atcButtonText.innerText = translation.product_sold_out || 'Sold Out';
      atcButton.disabled = true;
    }
  }

  function updatePrice(scope, variant, state) {
    var priceContainer = scope.querySelector('[data-price-container]');
    var price = scope.querySelector('[data-product-price]');
    var priceCompare = scope.querySelector('[data-product-price-compare]');
    var savingsBadge = scope.querySelector('[data-product-savings-badge]');
    var unavailableText = scope.querySelector('[data-unavailable-text]');

    if (priceContainer && price) {
      if (!variant || state === 'unavailable' || state === 'not-selected') {
        priceContainer.dataset.unavailable = 'true';
        if (unavailableText && window.PXUTheme && PXUTheme.translation) {
          unavailableText.innerText = PXUTheme.translation.product_unavailable;
        }
      } else {
        priceContainer.dataset.unavailable = 'false';

        if (variant.price > 0) {
          price.innerHTML = formatMoney(variant.price);
        } else if (variant.available) {
          price.innerHTML =
            (window.PXUTheme && PXUTheme.theme_settings && PXUTheme.theme_settings.free_text) || 'Free';
        } else {
          price.innerHTML = '';
        }

        if (priceCompare) {
          if (variant.compare_at_price > variant.price) {
            priceContainer.dataset.sale = 'true';
            priceContainer.dataset.comparePriceVisible = 'true';
            priceCompare.innerHTML = formatMoney(variant.compare_at_price);

            if (savingsBadge) {
              var percentage = Math.round(
                ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
              );
              var translation = (window.PXUTheme && PXUTheme.translation) || {};
              var badgeTemplate = translation.product_savings_badge_html || 'Save __PERCENT__%';
              savingsBadge.innerHTML = badgeTemplate.replace('__PERCENT__', percentage);
            }
          } else {
            priceContainer.dataset.sale = 'false';
            priceContainer.dataset.comparePriceVisible = 'false';
            priceCompare.innerHTML = '';
            if (savingsBadge) savingsBadge.innerHTML = '';
          }
        }

        priceContainer.dataset.soldOut = variant.available ? 'false' : 'true';
      }
    }

    updateAtc(scope, variant, state);
  }

  function resolveVariant(detail) {
    var variant = detail.variant;
    var product = detail.product;
    var state = detail.state;

    if (!variant && product && product.variants && state && /^\d+$/.test(String(state))) {
      variant = product.variants.find(function (v) {
        return String(v.id) === String(state);
      }) || false;
      if (variant) state = 'selected';
    }

    return { variant: variant, state: state };
  }

  function onVariantChange(event) {
    var detail = event.detail || {};
    var resolved = resolveVariant(detail);
    updatePrice(scopeFor(event.target), resolved.variant, resolved.state);
  }

  function bind(el) {
    if (!el || bound.has(el)) return;
    bound.add(el);
    el.addEventListener('variant-change', onVariantChange);
  }

  function bindAll(root) {
    (root || document).querySelectorAll('[data-variant-selection]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindAll(document);
    });
  } else {
    bindAll(document);
  }

  // Quick View injects product HTML after load
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('[data-variant-selection]')) bind(node);
        if (node.querySelectorAll) bindAll(node);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
